import { render, staticRenderFns } from "./gelirGiderTabloSablon.vue?vue&type=template&id=5671de7c&"
import script from "./gelirGiderTabloSablon.vue?vue&type=script&lang=js&"
export * from "./gelirGiderTabloSablon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports